// authReducer.js
import { LOGIN, LOGOUT ,LANG,SEARCH,LOGINMODAL , ISSIGNIN, ISDEVELOPERLOGIN} from './actionTypes';



const initialState = {

  isAuthenticated: false,
  uid: null,
  name: null,
  displayName:null,
  email: null,
  temp_id:null,
  packageid:1,
  status:null,
  temp_pkgid:null,
  lang: "eng",
  issign:true,
  search: false,
  loginModal:false,
  developername:null,
  developerrole:null,
   developeremail:null,
    developeruid:null
};

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN:
      return {
        ...state,
        isAuthenticated: true,
        uid: action.payload.uid,
        displayName:action.payload.displayName,
        packageid: action.payload.packageid,
        temp_pkgid: action.payload.temp_pkgid,
        temp_id: action.payload.temp_id,
        status: action.payload.status,
        name: action.payload.displayName,
        email: action.payload.email,
      };
      case ISDEVELOPERLOGIN:
      return {
        ...state,
        isAuthenticated: true,
        developername: action.payload.developername,
        developeremail: action.payload.developeremail,
        developeruid: action.payload.developeruid,
        developerrole: action.payload.developerrole,
        
      };
    case LOGOUT:
      return {
        ...state,
        isAuthenticated: false,
        uid: null,
        name: null,
        displayName:null,
        packageid:1,
        temp_pkgid:null,
        temp_id:null,
        status:null,
        email: null,
        developername:null,
        developerrole:null,
         developeremail:null,
          developeruid:null
      };
      
      case LANG:
      return {
        ...state,
        lang:action.payload.lang
      };

      case ISSIGNIN:
        return {
          ...state,
          issign:action.payload.issign
        };
      case SEARCH:
  
        return {
          ...state,
          search: action.payload.val
        };

        case LOGINMODAL:
        return {
          ...state,
          loginModal: action.payload.val
        };
      
    default:
      return state;
  }
};

export default authReducer;
